<template>
  <el-dialog
    :title="
      isReadonly
        ? 'View Role'
        : form.Id
        ? $t('text.edit_role')
        : $t('text.add_role')
    "
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="isReadonly"
    @close="closeDialog()"
    width="900px"
    class="add-role"
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      v-loading="loading"
      label-position="top"
      :class="isReadonly ? 'not-allowed' : ''"
      style="max-height: 80vh;"
    >
      <el-form-item :label="$t('text.role_name')" prop="Name">
        <el-input
          v-model="form.Name"
          :placeholder="$t('text.role_name')"
        ></el-input>
      </el-form-item>
      <div class="template-list">
        <div class="mb-10">
          <span>{{ $t('text.template') }}</span>
          <span class="ml-5">
            <el-tooltip
              effect="light"
              :content="$t('text.choose_permission_template_desc')"
            >
              <i class="el-icon-info cursor-pointer"></i>
            </el-tooltip>
          </span>
        </div>
        <span
          v-for="template in templateOptions"
          :key="template.RoleName"
          @click="handleTemplateChange(template.RoleName)"
          :class="
            selectedTemplateName === template.RoleName
              ? 'template-item active'
              : 'template-item'
          "
          >{{ template.RoleName }}</span
        >
      </div>
      <el-form-item :label="$t('text.role_permissions')">
        <el-table
          :data="permissionList"
          :span-method="objectSpanMethod"
          size="mini"
          border
        >
          <el-table-column :label="$t('text.level_1_module')">
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.GrandParentNodeAllChecked"
                :indeterminate="scope.row.GrandParentNodeInDeterminate"
                :disabled="parentNodeDisabled(scope.row)"
                @change="val => handleLevel1ModuleChange(val, scope.row)"
              >
                {{ $t('text.' + scope.row.grandParentNode) }}
              </el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :label="$t('text.level_2_module')">
            <template slot-scope="scope">
              <div v-if="scope.row.showParent">
                <el-checkbox
                  v-model="scope.row.ParentNodeAllChecked"
                  :indeterminate="scope.row.ParentNodeInDeterminate"
                  :disabled="parentNodeDisabled(scope.row)"
                  @change="val => handleLevel2ModuleChange(val, scope.row)"
                >
                  {{ $t('text.' + scope.row.parentNode) }}
                </el-checkbox>
              </div>
              <div v-else></div>
            </template>
          </el-table-column>
          <el-table-column label="Level 3 module">
            <template slot-scope="scope">
              <div v-if="scope.row.showCurrent">
                <el-checkbox
                  v-model="scope.row.CurrentNodeAllChecked"
                  :indeterminate="scope.row.CurrentNodeInDeterminate"
                  :disabled="parentNodeDisabled(scope.row)"
                  @change="val => handleLevel3ModuleChange(val, scope.row)"
                >
                  {{ $t('text.' + scope.row.currentNode) }}
                </el-checkbox>
              </div>
              <div v-else></div>
            </template>
          </el-table-column>
          <el-table-column
            width="250px"
            :label="$t('text.permissions')"
            class-name="permission-column"
          >
            <template slot-scope="scope">
              <el-checkbox
                v-for="permission in scope.row.permissions"
                :key="
                  permission.Name === 'Pseudonymized'
                    ? pseudonymizedKey
                    : permission.Name === 'Anonymized'
                    ? anonymizedKey
                    : permission.Id
                "
                v-model="permission.IsActive"
                :disabled="permission.Disabled"
                @change="checkedChange(permission.Name)"
                >{{ $t('text.' + permission.Name) }}</el-checkbox
              >
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer" v-if="!isReadonly">
      <el-button
        class="save-btn min-w-80"
        :loading="saveLoading"
        @click="submit()"
        >{{ $t('text.save').toUpperCase() }}</el-button
      >
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dialogVisible: false,
      isReadonly: false,
      form: {
        Id: '',
        Name: '',
        Modules: []
      },
      rules: {
        Name: [
          {
            required: true,
            message: this.$t('text.please_enter_role_name'),
            trigger: 'blur'
          }
        ]
      },
      permissionList: [],
      loading: false,
      saveLoading: false,
      pseudonymizedKey: 1, // Pseudonymized permission key
      anonymizedKey: 2, // Anonymized permission key
      selectedTemplateName: null,
      templateOptions: [],
      templateOptionsLoading: false
    }
  },
  props: {
    refreshParent: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  computed: {
    specialPermissionObj() {
      // type will be Pseudonymized or Anonymized
      return type => {
        let obj
        this.permissionList.forEach(row => {
          if (
            row.currentNode === 'Data Privacy' &&
            row.parentNode === 'Data Privacy'
          ) {
            row.permissions.forEach(permission => {
              if (permission.Name === type) {
                obj = permission
                return
              }
            })
          }
        })
        return obj
      }
    },
    parentNodeDisabled() {
      return node => {
        if (
          node.currentNode === 'Dashboard' ||
          node.parentNode === 'Dashboard' ||
          node.grandParentNode === 'Dashboard'
        )
          return false
        return this.privacyModeEnable
      }
    },
    // user have select privacy mode, When privacy mode is clicked, make sure only the dashboard mode gets active. All others should be deactivated
    privacyModeEnable() {
      let enable = false
      this.permissionList.forEach(row => {
        if (
          row.currentNode === 'Data Privacy' &&
          row.parentNode === 'Data Privacy'
        ) {
          row.permissions.forEach(permission => {
            if (permission.Name === 'Private') {
              enable = permission.IsActive
            }
          })
        }
      })
      return enable
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
      this.getRoleDetail()
      if (!this.form.Id) {
        this.getTemplateOptions()
      }
    },
    closeDialog() {
      this.form = {
        Id: '',
        Name: '',
        Modules: []
      }
      this.selectedTemplateName = null
      this.$refs.form.resetFields()
      this.isReadonly = false
      this.dialogVisible = false
    },
    objectSpanMethod({ row, rowIndex, columnIndex }) {
      // Merge the first column
      if (columnIndex === 0) {
        // When the content of the previous line is the same as that of the previous line, returning 0 means elimination
        if (
          rowIndex > 0 &&
          row['grandParentId'] ===
            this.permissionList[rowIndex - 1]['grandParentId']
        ) {
          return {
            rowspan: 0,
            colspan: 0
          }
        } else {
          let rows = 1
          // Conversely, query how many rows of the same content are merged
          for (let i = rowIndex; i < this.permissionList.length - 1; i++) {
            if (
              row['grandParentId'] ===
              this.permissionList[i + 1]['grandParentId']
            ) {
              rows++
            }
          }
          // Returns the number of rows of the same content
          return {
            rowspan: rows,
            colspan: 1
          }
        }
      }
      if (columnIndex === 1) {
        // When the content of the previous line is the same as that of the previous line, returning 0 means elimination
        if (
          rowIndex > 0 &&
          row['parentId'] === this.permissionList[rowIndex - 1]['parentId']
        ) {
          return {
            rowspan: 0,
            colspan: 0
          }
        } else {
          let rows = 1
          // Conversely, query how many rows of the same content are merged
          for (let i = rowIndex; i < this.permissionList.length - 1; i++) {
            if (row['parentId'] === this.permissionList[i + 1]['parentId']) {
              rows++
            }
          }
          // Returns the number of rows of the same content
          return {
            rowspan: rows,
            colspan: 1
          }
        }
      }
    },
    // whenever Pseudonymized permission or Anonymized is selected, user should not be able to enable Patients -> Monitor -> Edit permission.
    operatePatientsMonitorEditPermission() {
      let patientMonitorEdit
      this.permissionList.forEach(row => {
        if (row.currentNode === 'Patients' && row.parentNode === 'Patients') {
          row.permissions.forEach(permission => {
            if (permission.Name === 'Edit') {
              patientMonitorEdit = permission
            }
          })
        }
      })

      if (
        !patientMonitorEdit ||
        !this.specialPermissionObj('Pseudonymized') ||
        !this.specialPermissionObj('Anonymized')
      ) {
        return false
      }

      if (
        patientMonitorEdit.IsActive &&
        this.specialPermissionObj('Pseudonymized').IsActive
      ) {
        this.cancleCheckSpecialPermission('Pseudonymized')
      }

      if (
        patientMonitorEdit.IsActive &&
        this.specialPermissionObj('Anonymized').IsActive
      ) {
        this.cancleCheckSpecialPermission('Anonymized')
      }

      if (
        this.specialPermissionObj('Pseudonymized').IsActive &&
        this.specialPermissionObj('Anonymized').IsActive
      ) {
        this.cancleCheckSpecialPermission('Anonymized', false)
      }

      this.permissionList.forEach((row, parentIdx) => {
        if (row.currentNode === 'Patients' && row.parentNode === 'Patients') {
          let permissions = row.permissions.map(permission => {
            return {
              ...permission,
              Disabled:
                permission.Name === 'Edit'
                  ? !!(
                      this.specialPermissionObj('Pseudonymized').IsActive ||
                      this.specialPermissionObj('Anonymized').IsActive
                    )
                  : false
            }
          })
          this.$set(this.permissionList, parentIdx, {
            ...this.permissionList[parentIdx],
            permissions: permissions
          })
        }
        if (
          row.currentNode === 'Data Privacy' &&
          row.parentNode === 'Data Privacy'
        ) {
          let permissions = row.permissions.map(permission => {
            return {
              ...permission,
              Disabled:
                permission.Name === 'Pseudonymized'
                  ? !!this.specialPermissionObj('Anonymized').IsActive
                  : permission.Name === 'Anonymized'
                  ? !!this.specialPermissionObj('Pseudonymized').IsActive
                  : false
            }
          })
          this.$set(this.permissionList, parentIdx, {
            ...this.permissionList[parentIdx],
            permissions: permissions
          })
        }
      })
    },
    cancleCheckSpecialPermission(type, showAlert = true) {
      // type will be Pseudonymized or Anonymized
      if (showAlert) {
        let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
        this.$confirm(
          `<div class='warning-content'>${
            type === 'Pseudonymized'
              ? this.$t('text.pseudonymized_permission_warning', {
                  patient: this.$firstLetterCapitalize(
                    this.$store.state.locale.patient
                  )
                })
              : this.$t('text.anonymized_permission_warning', {
                  patient: this.$firstLetterCapitalize(
                    this.$store.state.locale.patient
                  )
                })
          }</div>` + `<img class='warning-icon' src=${warningIconUrl}>`,
          this.$t('text.warning'),
          {
            confirmButtonText: this.$t('text.ok').toUpperCase(),
            confirmButtonClass: 'confirm-btn',
            type: 'warning',
            customClass: 'delete-warning-box',
            showClose: true,
            closeOnClickModal: false,
            dangerouslyUseHTMLString: true,
            showCancelButton: false
          }
        )
      }

      this.permissionList.forEach((row, parentIdx) => {
        if (
          row.currentNode === 'Data Privacy' &&
          row.parentNode === 'Data Privacy'
        ) {
          let permissions = row.permissions.map(permission => {
            return {
              ...permission,
              IsActive: permission.Name === type ? false : permission.IsActive
            }
          })
          this.$set(this.permissionList, parentIdx, {
            ...this.permissionList[parentIdx],
            permissions: permissions
          })
        }
      })

      if (type === 'Pseudonymized') {
        this.pseudonymizedKey = Math.random()
      } else {
        this.anonymizedKey = Math.random()
      }
      return
    },
    // When privacy mode is clicked, make sure only the dashboard mode gets active. All others should be deactivated.
    operatePrivacyModePermission() {
      this.permissionList = this.permissionList.map(row => {
        return {
          ...row,
          permissions: row.permissions.map(permission => {
            return {
              ...permission,
              Disabled: this.privacyModeEnable
                ? row.currentNode === 'Dashboard' ||
                  permission.Name === 'Private'
                  ? false
                  : true
                : false,
              IsActive: this.privacyModeEnable
                ? row.currentNode === 'Dashboard' ||
                  permission.Name === 'Private'
                  ? true
                  : false
                : permission.IsActive
            }
          })
        }
      })
    },
    checkedChange(permissionName = null) {
      this.operatePatientsMonitorEditPermission()
      if (permissionName === 'Private' || this.privacyModeEnable) {
        this.operatePrivacyModePermission()
      }
      this.permissionList.forEach((row, index) => {
        // Handle level 3 permission status
        let checked = row.permissions.filter(item => item.IsActive)
        row.CurrentNodeAllChecked = checked.length === row.permissions.length
        row.CurrentNodeInDeterminate =
          checked.length > 0 && checked.length < row.permissions.length
        this.$set(this.permissionList, index, row)

        // Handle level 2 permission status
        let allPermissionsBelongToParent = []
        this.permissionList.forEach(item => {
          if (item.parentId === row.parentId) {
            allPermissionsBelongToParent = allPermissionsBelongToParent.concat(
              item.permissions
            )
          }
        })
        let parentChecked = allPermissionsBelongToParent.filter(
          item => item.IsActive
        )
        row.ParentNodeAllChecked =
          parentChecked.length === allPermissionsBelongToParent.length
        row.ParentNodeInDeterminate =
          parentChecked.length > 0 &&
          parentChecked.length < allPermissionsBelongToParent.length
        this.$set(this.permissionList, index, row)

        // Handle level 1 permission status
        let allPermissionsBelongToGrandParent = []
        this.permissionList.forEach(item => {
          if (item.grandParentId === row.grandParentId) {
            allPermissionsBelongToGrandParent = allPermissionsBelongToGrandParent.concat(
              item.permissions
            )
          }
        })
        let grandParentChecked = allPermissionsBelongToGrandParent.filter(
          item => item.IsActive
        )
        row.GrandParentNodeAllChecked =
          grandParentChecked.length === allPermissionsBelongToGrandParent.length
        row.GrandParentNodeInDeterminate =
          grandParentChecked.length > 0 &&
          grandParentChecked.length < allPermissionsBelongToGrandParent.length
        this.$set(this.permissionList, index, row)
      })
    },
    getRoleDetail() {
      this.permissionList = []
      this.loading = true
      let id = this.form.Id || 0
      ApiService.GetRolePermission(
        id,
        this.$store.getters[`user/selecteOrganisationId`]
      )
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.permissionList = []
            this.form = response.data.data
            this.buildPermissions(response.data.data.Modules)
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    buildPermissions(permissionObj) {
      this.permissionList = []
      permissionObj.forEach(item => {
        if (item.Permissions && item.Permissions.length) {
          this.permissionList.push({
            grandParentNode: item.Name,
            grandParentId: item.Id,
            showGrandParent: true,
            parentNode: item.Name,
            parentId: item.Id,
            showParent: false,
            currentNode: item.Name,
            currentId: item.Id,
            showCurrent: false,
            permissions: item.Permissions,
            CurrentNodeAllChecked: false
          })
        }
        if (item.ChildModules && item.ChildModules.length) {
          item.ChildModules.forEach(subItem => {
            if (subItem.Permissions && subItem.Permissions.length) {
              this.permissionList.push({
                grandParentNode: item.Name,
                grandParentId: item.Id,
                showGrandParent: true,
                parentNode: subItem.Name,
                parentId: subItem.Id,
                showParent: true,
                currentNode: subItem.Name,
                currentId: subItem.Id,
                showCurrent: false,
                permissions: subItem.Permissions,
                CurrentNodeAllChecked: false
              })
            }
            if (subItem.ChildModules && subItem.ChildModules.length) {
              subItem.ChildModules.forEach(child => {
                if (child.Permissions && child.Permissions.length) {
                  this.permissionList.push({
                    grandParentNode: item.Name,
                    grandParentId: item.Id,
                    showGrandParent: true,
                    parentNode: subItem.Name,
                    parentId: subItem.Id,
                    showParent: true,
                    currentNode: child.Name,
                    currentId: child.Id,
                    showCurrent: true,
                    permissions: child.Permissions,
                    CurrentNodeAllChecked: false
                  })
                }
              })
            }
          })
        }
      })
      this.checkedChange()
      if (this.privacyModeEnable) {
        this.operatePrivacyModePermission()
      }
    },
    handleLevel3ModuleChange(isChecked, row) {
      row.CurrentNodeAllChecked = isChecked
      row.permissions = row.permissions.map(item => {
        return {
          ...item,
          IsActive: item.Disabled ? item.IsActive : isChecked
        }
      })
      this.checkedChange()
    },
    handleLevel2ModuleChange(isChecked, row) {
      row.ParentNodeAllChecked = isChecked
      this.permissionList.forEach(item => {
        if (item.parentId === row.parentId) {
          item.CurrentNodeAllChecked = isChecked
          item.permissions = item.permissions.map(permission => {
            return {
              ...permission,
              IsActive: permission.Disabled ? permission.IsActive : isChecked
            }
          })
        }
      })
      this.checkedChange()
    },
    handleLevel1ModuleChange(isChecked, row) {
      row.GrandParentNodeAllChecked = isChecked
      this.permissionList.forEach(item => {
        if (item.grandParentId === row.grandParentId) {
          item.CurrentNodeAllChecked = isChecked
          item.ParentNodeAllChecked = isChecked
          item.permissions = item.permissions.map(permission => {
            return {
              ...permission,
              IsActive: permission.Disabled ? permission.IsActive : isChecked
            }
          })
        }
      })
      this.checkedChange()
    },
    formatPermissions() {
      let permissionList = JSON.parse(JSON.stringify(this.permissionList))
      this.form.Modules.forEach((module, index) => {
        permissionList.forEach(ele => {
          if (
            ele.grandParentId === module.Id &&
            ele.parentId === module.Id &&
            ele.currentId === module.Id
          ) {
            module.Permissions = ele.permissions
            this.$set(this.form.Modules, index, module)
          }
        })
        if (module.ChildModules.length) {
          module.ChildModules.forEach((childModule, key) => {
            permissionList.forEach(ele => {
              if (
                ele.grandParentId === module.Id &&
                ele.parentId === childModule.Id &&
                ele.currentId === childModule.Id
              ) {
                childModule.Permissions = ele.permissions
                this.$set(
                  this.form.Modules[index].ChildModules,
                  key,
                  childModule
                )
              }
            })
            childModule.ChildModules.forEach((subModule, i) => {
              permissionList.forEach(ele => {
                if (
                  ele.grandParentId === module.Id &&
                  ele.parentId === childModule.Id &&
                  ele.currentId === subModule.Id
                ) {
                  subModule.Permissions = ele.permissions
                  this.$set(
                    this.form.Modules[index].ChildModules[key].ChildModules,
                    i,
                    subModule
                  )
                }
              })
            })
          })
        }
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.formatPermissions()
          this.$nextTick(() => {
            this.save()
          })
        }
      })
    },
    save() {
      this.saveLoading = true
      ApiService.SaveRolePermission(this.form.Id, {
        Name: this.form.Name,
        Modules: this.form.Modules,
        OrganisationId: this.$store.getters[`user/selecteOrganisationId`]
      })
        .then(response => {
          this.saveLoading = false
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.saved_successfully')
            })
            this.closeDialog()
            if (this.refreshParent) {
              this.$parent.getRoles()
            }
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.saveLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    getTemplateOptions() {
      this.templateOptionsLoading = true
      ApiService.GetTemplateRoles()
        .then(response => {
          this.templateOptionsLoading = false
          if (response.data.success) {
            this.templateOptions = response.data.data || []
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.templateOptionsLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    handleTemplateChange(role) {
      if (!role) return false
      this.selectedTemplateName = role
      this.loading = true
      ApiService.GetTemplateRolePermissions(this.selectedTemplateName)
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.buildPermissions(response.data.data.Modules)
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-table {
  label::v-deep {
    margin-bottom: 0;
  }
}
</style>
